import Logger from './Logger'

import { QS_PARAM_IDENTIFIER, PROCESS_ENV_VALUE } from '../constants'

export const QS_PARAM_NAME = QS_PARAM_IDENTIFIER

const { href, search } = window.location
const searchUrlParams = new URLSearchParams(search)

export const isActiveByQueryParams = searchUrlParams.get(QS_PARAM_IDENTIFIER) === 'true'
export const isActiveByEnv = PROCESS_ENV_VALUE === true
export const isActive = isActiveByEnv || isActiveByQueryParams

if (isActiveByQueryParams) {
  const newUrl = new URL(href)
  newUrl.searchParams.delete(QS_PARAM_IDENTIFIER)
  window.history.replaceState(null, '', newUrl.toString());
}

/**
 *
 * @param name
 * @param options
 * @returns {Logger}
 */
export function createLogger(name, {
  prefix = '',
  silent = false,
  styled = true,
  discardEnvironment = false
}) {
  const options = {
    prefix,
    styled,
    silent: discardEnvironment ? silent : !isActive || silent,
  }

  return new Logger(name, { ...options })
}
